import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _ListItemIcon, _Typography;
/* eslint-disable max-lines */
/* eslint-disable no-nested-ternary */
import React, { useRef, useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MenuList from '@mui/material/MenuList';
import Typography from '@mui/material/Typography';
import ListItemIcon from '@mui/material/ListItemIcon';
import { SideNavButton } from './internal/SideNavButton';
import { SideNavPopover } from './internal/SideNavPopover';
import { Help } from '../icons/Help';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var HELP = 'help';
var LEFT_SIDE_NAV = 'left-side-nav';
export function LeftSideNav(props) {
  var activeSideNavItem = props.activeSideNavItem,
    _props$headerHeight = props.headerHeight,
    headerHeight = _props$headerHeight === void 0 ? 100 : _props$headerHeight,
    hoverRequired = props.hoverRequired,
    _props$isAuthenticate = props.isAuthenticated,
    isAuthenticated = _props$isAuthenticate === void 0 ? false : _props$isAuthenticate,
    isHelpNavItemVisible = props.isHelpNavItemVisible,
    navItems = props.navItems,
    onHelpNavItemClick = props.onHelpClick,
    onNavItemClickProp = props.onNavItemClick,
    setActiveSideNavItem = props.setActiveSideNavItem,
    sx = props.sx,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'primary' : _props$variant;
  var menuItem = {
    key: LEFT_SIDE_NAV
  };
  var helpNavItem = {
    key: HELP
  };
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    openItems = _useState2[0],
    setOpenItems = _useState2[1];
  var _useState3 = useState(activeSideNavItem),
    _useState4 = _slicedToArray(_useState3, 2),
    activeTopItem = _useState4[0],
    setActiveTopItem = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    anchorEl = _useState6[0],
    setAnchorEl = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    hoveredItem = _useState8[0],
    setHoveredItem = _useState8[1];
  var stackRef = useRef(null);
  var isPrimary = variant === 'primary';
  useEffect(function () {
    setActiveTopItem(activeSideNavItem);
  }, [activeSideNavItem]);
  var onNavItemClick = function onNavItemClick(navItem, level, event) {
    setAnchorEl((event == null ? void 0 : event.currentTarget) || null);
    if (navItem.key === HELP) {
      setActiveTopItem(navItem);
      onHelpNavItemClick == null ? void 0 : onHelpNavItemClick();
    } else {
      var _openItems$;
      if (level === 0) {
        setActiveTopItem(navItem);
      }
      if ((openItems == null ? void 0 : (_openItems$ = openItems[0]) == null ? void 0 : _openItems$.key) === (navItem == null ? void 0 : navItem.key)) {
        setActiveTopItem(undefined);
        setOpenItems([]);
      } else if (!navItem.navItems || navItem.route || navItem.url) {
        setActiveSideNavItem(level === 0 ? navItem : activeTopItem);
        onNavItemClickProp(navItem);
        setOpenItems([]);
        setHoveredItem(null);
      } else {
        setOpenItems([navItem]);
      }
    }
  };
  var onNavItemHover = function onNavItemHover(navItem, level) {
    var newOpenItems = _toConsumableArray(openItems);
    newOpenItems.length = level;
    if (navItem.navItems) {
      newOpenItems.push(navItem);
    }
    setOpenItems(newOpenItems);
    setTimeout(function () {
      setOpenItems(_toConsumableArray(newOpenItems));
    }, 1);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(SytledMenuList, {
      "aria-busy": "true",
      className: "sidenav-base-menulist",
      disablePadding: true,
      isHover: !!hoveredItem,
      isPrimary: isPrimary,
      onMouseEnter: function onMouseEnter() {
        if (!hoveredItem && hoverRequired) {
          setHoveredItem(menuItem);
        }
      },
      onMouseLeave: function onMouseLeave() {
        if ((!openItems || (openItems == null ? void 0 : openItems.length) === 0) && hoverRequired) {
          setHoveredItem(null);
        }
      },
      onMouseOver: function onMouseOver() {
        if (!hoveredItem && hoverRequired) {
          setHoveredItem(menuItem);
        }
      },
      ref: stackRef,
      sx: sx,
      "data-element": "SytledMenuList",
      "data-source-file": "LeftSideNav.tsx",
      children: [navItems.map(function (navItem) {
        var _navItem$navItems;
        var isOpen = navItem === openItems[0];
        var isActive = navItem.key === (activeTopItem == null ? void 0 : activeTopItem.key);
        return /*#__PURE__*/_jsx(SideNavButton, {
          active: isActive,
          "data-testid": "".concat(navItem.key, "-MenuItem"),
          hasItems: !!navItem.navItems && ((_navItem$navItems = navItem.navItems) == null ? void 0 : _navItem$navItems.length) > 0,
          hoveredItem: hoveredItem,
          isOpen: isOpen || isActive,
          isPrimary: isPrimary,
          navItem: navItem,
          onClick: function onClick(e) {
            return onNavItemClick(navItem, 0, e);
          },
          setHoveredItem: setHoveredItem,
          children: navItem.label || navItem.key
        }, navItem.key);
      }), isHelpNavItemVisible && /*#__PURE__*/_jsxs(StyledBox, {
        isActive: (activeTopItem == null ? void 0 : activeTopItem.key) === HELP,
        isHover: !!hoveredItem,
        isPrimary: isPrimary,
        onClick: function onClick(e) {
          return onNavItemClick(helpNavItem, 0, e);
        },
        children: [_ListItemIcon || (_ListItemIcon = /*#__PURE__*/_jsx(ListItemIcon, {
          children: /*#__PURE__*/_jsx(Help, {})
        })), _Typography || (_Typography = /*#__PURE__*/_jsx(Typography, {
          children: "Help"
        }))]
      })]
    }), /*#__PURE__*/_jsx(SideNavPopover, {
      anchorEl: anchorEl || stackRef.current,
      anchorTopPosition: (anchorEl == null ? void 0 : anchorEl.getBoundingClientRect().top) || 0,
      headerHeight: headerHeight,
      isAuthenticated: isAuthenticated,
      isPrimary: isPrimary,
      onClose: function onClose() {
        setActiveTopItem(activeSideNavItem);
        setOpenItems([]);
        setHoveredItem(null);
      },
      onNavItemClick: onNavItemClick,
      onNavItemHover: onNavItemHover,
      open: Boolean(openItems.length),
      openItems: openItems,
      "data-element": "SideNavPopover",
      "data-source-file": "LeftSideNav.tsx"
    })]
  });
}
var SytledMenuList = styled(MenuList, {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isPrimary' && props !== 'isHover';
  }
})(function (_ref) {
  var isHover = _ref.isHover,
    isPrimary = _ref.isPrimary,
    theme = _ref.theme;
  return {
    '& div.MuiListItemButton-root': {
      '&.active': {
        '&:hover': {
          '& > *': {
            backgroundColor: isPrimary ? "".concat(theme.palette.primary[50], " !important") : theme.palette.common.white
          }
        },
        '&:not(:first-of-type)': {
          '& svg > path': {
            '&:not(:last-child)': {
              fill: isPrimary ? theme.palette.primary[900] : theme.palette.primary.main
            }
          }
        },
        backgroundColor: isPrimary ? "".concat(theme.palette.primary[50], " !important") : theme.palette.common.white
      },
      '&:first-of-type': {
        '&:hover': {
          '& > *': {
            backgroundColor: isPrimary ? theme.palette.grey[50] : theme.palette.common.white
          },
          backgroundColor: isPrimary ? theme.palette.grey[50] : theme.palette.common.white
        }
      },
      '&:not(:first-of-type)': {
        '&:hover': {
          '& > *': {
            backgroundColor: isPrimary ? theme.palette.grey[50] : theme.palette.common.white
          },
          '& svg > path': {
            '&:first-of-type': {
              fill: isPrimary ? theme.palette.primary[900] : theme.palette.primary.main
            },
            '&:not(:last-child)': {
              fill: isPrimary ? theme.palette.primary[900] : theme.palette.primary.main
            }
          },
          backgroundColor: isPrimary ? theme.palette.grey[50] : theme.palette.common.white
        }
      }
    },
    alignItems: 'center',
    backgroundColor: isPrimary ? theme.palette.common.white : theme.palette.neutral[10],
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: isPrimary ? '0 8px' : 0,
    width: isPrimary && isHover ? 240 : !isPrimary && isHover ? 260 : 64
  };
});
var StyledBox = styled(Box, {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isPrimary' && props !== 'isHover' && props !== 'isVisible' && props !== 'isActive';
  }
})(function (_ref2) {
  var _ref2$isActive = _ref2.isActive,
    isActive = _ref2$isActive === void 0 ? false : _ref2$isActive,
    _ref2$isHover = _ref2.isHover,
    isHover = _ref2$isHover === void 0 ? false : _ref2$isHover,
    _ref2$isPrimary = _ref2.isPrimary,
    isPrimary = _ref2$isPrimary === void 0 ? false : _ref2$isPrimary,
    theme = _ref2.theme;
  return {
    '& .MuiListItemIcon-root': {
      '& .MuiSvgIcon-root': {
        '& svg > path': {
          fill: isPrimary && isActive ? theme.palette.primary[900] : !isPrimary && isActive ? theme.palette.primary.main : !isPrimary && !isActive ? theme.palette.grey[500] : theme.palette.grey[600]
        },
        height: 24,
        width: 24
      },
      alignItems: 'flex-start',
      backgroundColor: isActive && isPrimary ? theme.palette.primary[50] : isActive && !isPrimary ? theme.palette.common.white : !isActive && !isPrimary ? theme.palette.neutral[10] : 'transparent',
      border: isPrimary ? 'none' : "1px solid ".concat(theme.palette.grey[300]),
      borderRadius: 4,
      color: isActive && isPrimary ? theme.palette.primary[900] : isActive && !isPrimary ? theme.palette.primary.main : !isActive && !isPrimary ? theme.palette.grey[500] : theme.palette.grey[600],
      display: 'flex',
      flexDirection: 'row',
      height: isPrimary ? 48 : 36,
      margin: isPrimary ? '0 8px' : '0 12px',
      minWidth: isPrimary ? 48 : 36,
      padding: isHover && isPrimary ? '12px 0 12px 12px' : !isPrimary ? 6 : 12
    },
    '& .MuiTypography-root': {
      color: isActive && isPrimary ? theme.palette.primary[900] : isActive && !isPrimary ? theme.palette.primary.main : !isActive && !isPrimary ? theme.palette.grey[700] : theme.palette.grey[600],
      display: isHover ? 'block' : 'none',
      fontSize: '14px',
      textAlign: 'left',
      width: '100%'
    },
    '&:hover': {
      '& .MuiListItemIcon-root': {
        '&:first-of-type': {
          '& svg > path': {
            fill: isPrimary ? theme.palette.primary[900] : theme.palette.primary.main
          }
        },
        backgroundColor: isActive && isPrimary ? theme.palette.primary[50] : (isActive || isHover) && !isPrimary ? theme.palette.common.white : !isActive && !isPrimary ? theme.palette.neutral[10] : theme.palette.grey[50]
      },
      '& .MuiTypography-root': {
        color: isPrimary ? theme.palette.primary[900] : theme.palette.primary.main,
        fontSize: '14px'
      },
      backgroundColor: isActive && isPrimary ? theme.palette.primary[50] : !isActive && !isPrimary ? theme.palette.neutral[10] : theme.palette.grey[50]
    },
    alignItems: 'center',
    backgroundColor: isActive && isPrimary ? theme.palette.primary[50] : 'transparent',
    bottom: 8,
    cursor: 'pointer',
    display: 'flex',
    margin: isPrimary ? '0 4px' : 0,
    position: 'fixed',
    width: isPrimary && isHover ? 240 : !isPrimary && isHover ? 260 : 64
  };
});